module.exports = __webpack_public_path__ + "public/SiteIcons/tripChatIcon.svg?fec31431";